// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6805":"e3086cbf","7868":"c8d65838","8295":"08b47904"}[chunkId] + ".chunk.css";
};